'use client'

import { useState, useEffect } from 'react'
import s from './PhoneFeatures.module.scss'
import Image from 'next/image'
import { ButtonOrLink } from '@/components/ButtonOrLink'
import { useDict } from '@/lib'
import { ModalContact } from '@/components/ModalContact'
import { ExpandableCards } from '@/components/ExpandableCards'
import { WithColorInBackgroundWrapper } from '@/wrappers/WithColorInBackgroundWrapper'

export function PhoneFeatures() {
  const [activeIndex, setActiveIndex] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [globalSocials, setGlobalSocials] = useState<Record<
    string,
    string
  > | null>(null)
  const [companyData, setCompanyData] = useState<Record<
    string,
    string
  > | null>(null)
  const dict = useDict('homepage/phone')

  // Załaduj globalne dane wcześniej
  useEffect(() => {
    const loadGlobalData = async () => {
      try {
        const response = await fetch('/api/global-links')
        if (response.ok) {
          const data = await response.json()
          setGlobalSocials(data.socials)
          setCompanyData(data.company)
        }
      } catch (error) {
        console.error('Error loading global data:', error)
      }
    }
    loadGlobalData()
  }, [])

  if (!dict) return null // lub spinner / loading placeholder

  return (
    <WithColorInBackgroundWrapper backgroundColor="accent-bright">
      <div className={s.root}>
        <div className={s.grid}>
          <div className={s.phone}>
            <div className={s.phoneBase}>
              <Image
                src="/photos/screenBase.webp"
                alt="Phone"
                fill
                loading="lazy"
                quality={95}
                unoptimized
              />
            </div>
            <div className={s.phoneScreen}>
              {dict.features.map((feature: any, index: number) => (
                <Image
                  key={index}
                  src={`/photos/screen${index + 1}.webp`}
                  alt={`Screen ${index + 1}`}
                  fill
                  loading="lazy"
                  quality={95}
                  unoptimized
                  className={`${s.screenImage} ${
                    index === activeIndex ? s.active : ''
                  }`}
                />
              ))}
            </div>
          </div>

          <div className={s.content}>
            <span className={s.label}>{dict.label}</span>
            <h2 className={s.title}>{dict.title.normal}</h2>
            <p className={s.text}>{dict.text}</p>

            <ExpandableCards
              items={dict.features}
              onActiveChange={setActiveIndex}
              defaultActiveIndex={0}
              className="phoneFeatures"
            />

            <div className={s.actions}>
              <ModalContact
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                globalSocials={globalSocials}
                companyData={companyData}
              />

              <ButtonOrLink
                as="button"
                variant="primary"
                iconRight="Arrow2Icon"
                onClick={() => setIsModalOpen(true)}
              >
                {dict.buttons.primary.text}
              </ButtonOrLink>

              <ButtonOrLink
                as="link"
                href="/strefa-nauki"
                variant="text"
                classes={s.pulseLink}
                iconRight="Arrow2Icon"
                onClick={undefined as never}
                type={undefined as never}
              >
                {dict.buttons.secondary.text}
              </ButtonOrLink>
            </div>
          </div>
        </div>
      </div>
    </WithColorInBackgroundWrapper>
  )
}
